"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _contexts = require("../contexts");
var _DefaultSpinner = _interopRequireDefault(require("../components/spinner/DefaultSpinner"));
require("../style/main.css");
var _PaymentContainer = _interopRequireDefault(require("../components/paymentContainer/PaymentContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Payment = /*#__PURE__*/function () {
  function Payment(data) {
    _classCallCheck(this, Payment);
    this.metaData = data['metaData'] || {};
    this.initiateConfigCallback = data['initiateConfigCallback'] || function () {};
    this.authCallBack = data['authCallback'] || function () {};
    this.spinner = data['spinner'] || /*#__PURE__*/_react.default.createElement(_DefaultSpinner.default, {
      overlay: true
    });
    this.components = data['components'];
    this.newCustomData = {
      metaData: this.metaData,
      environment: data['environment'],
      paymentPlusConfig: data['paymentPlusData'],
      cart: data['cart'],
      userDetails: data['userDetails'] || {},
      checkoutId: data['checkoutId'],
      caseId: data['caseId'] || undefined
    };
    this.customFunctions = data['customFunctions'] ? {
      beforeSubmit: data['customFunctions']['beforeSubmit'],
      customValidate: data['customFunctions']['customValidate'],
      postValidate: data['customFunctions']['postValidate'],
      onClickPaypal: data['customFunctions']['onClickPaypal'],
      onCancel: data['customFunctions']['onCancel'] || function () {},
      onError: data['customFunctions']['onError'] || function () {},
      onPaymentMethodChange: data['customFunctions']['onPaymentMethodChange'] || function () {},
      onAddressChange: data['customFunctions']['onAddressChange'] || function () {}
    } : {};

    // Bind this to the scope of required methods
    this.render = this.render.bind(this);
    this.paymentWidget = /*#__PURE__*/_react.default.createElement("div", {
      id: "payment-page"
    }, /*#__PURE__*/_react.default.createElement(_contexts.AppContextProvider, null, /*#__PURE__*/_react.default.createElement(_PaymentContainer.default, {
      customSpinner: this.spinner,
      inputCustomData: this.newCustomData,
      components: this.components,
      customFunctions: this.customFunctions,
      customInitiateConfigCallback: this.initiateConfigCallback,
      customAuthCallBack: this.authCallBack
    })));
  }

  /**
   * It renders react component into the DOM if provided,
   * or else returns the prepared component.
   * @param: (optional) Id attribute to render payment widget
   * @returns: If id is provided render the component, else return the payment widget
   */
  _createClass(Payment, [{
    key: "render",
    value: function render(dom) {
      return dom ? (0, _reactDom.render)(this.paymentWidget, document.getElementById(dom)) : this.paymentWidget;
    }
  }]);
  return Payment;
}();
var _default = Payment;
exports.default = _default;